import { useParams } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { useApi } from '@/lib/api';
import { ErrorText } from '@/components/ui';
import { UserProfileView } from '@/components/user-profile';
import { useOrgContext } from './layout';

/**
 * A member's profile for the organization's admins: their roles here, and the
 * courses, quiz results and certificates from their time in this organization
 * and the ones under it.
 */
export function OrgMemberProfilePage() {
  const { org } = useOrgContext();
  const { userId = '' } = useParams();
  const api = useApi();
  const profile = useQuery({
    queryKey: ['memberProfile', org.id, userId],
    queryFn: () => api.memberProfile(org.id, userId),
  });
  if (profile.isPending) return <p className="text-sm text-muted-foreground">Loading…</p>;
  if (profile.isError) return <ErrorText error={profile.error} />;
  return (
    <UserProfileView
      profile={profile.data}
      back={{ to: `/organizations/${org.id}/members`, label: 'Members' }}
      scopeNote={`Activity in ${org.name} and the organizations under it, from when they joined. Their other learning stays private.`}
    />
  );
}
